import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';

// OAuth 一般公開の必須要件を満たす公開ホームページ (issue #123 連動)。
// - ログイン不要で表示できる (Google reviewer が root を見てもログイン画面が出ない)
// - アプリの目的を説明する
// - /fingering (アプリ本体) への導線と、privacy/terms への静的リンクを持つ
// SPA の / ルートはこのページを描画する (旧: /fingering へ即リダイレクト)。

const FEATURES: { icon: string; title: string; desc: string }[] = [
  {
    icon: '🎼',
    title: 'PDFから運指を自動付与',
    desc: 'ギター楽譜のPDFを読み込むと、OMR と music21 で各音に運指（弦・フレット）を自動で割り当てます。',
  },
  {
    icon: '📄',
    title: 'PDF・MP3を出力',
    desc: '運指を書き込んだ楽譜PDFと、確認用の演奏音源MP3を書き出せます。',
  },
  {
    icon: '✏️',
    title: 'エディタで微調整',
    desc: '自動生成された運指は、ブラウザ上のエディタで弦・フレットを自由に編集できます。',
  },
  {
    icon: '☁️',
    title: 'Google Driveに保存・復元',
    desc: '生成物をご自身のGoogle Driveに保存し、履歴からいつでも復元できます（任意機能・drive.file スコープのみ使用）。',
  },
];

const LandingPage: React.FC = () => {
  usePageTitle('おまかせ運指くん');
  return (
    <div className="max-w-3xl mx-auto py-8 px-4">
      <header className="text-center mb-9">
        <img
          src="/omakase-unshi-kun.png"
          alt="おまかせ運指くん"
          className="w-28 h-28 md:w-32 md:h-32 mx-auto mb-4 object-contain"
        />
        <h1 className="text-3xl md:text-4xl font-bold text-brand-purple mb-3">おまかせ運指くん</h1>
        <p className="text-slate-600 text-base md:text-lg leading-relaxed">
          ギター楽譜のPDFから運指を自動で付与し、PDF・MP3の出力、エディタでの編集、
          Google Driveへの保存・復元までできる無料のWebアプリです。
        </p>
      </header>

      <div className="text-center mb-11">
        <a
          href="/fingering"
          className="inline-block px-9 py-3.5 rounded-xl bg-gradient-to-r from-brand-purple to-indigo-500 text-white font-bold text-lg shadow-md shadow-indigo-500/25 hover:opacity-90 active:scale-[0.98] transition"
        >
          はじめる →
        </a>
        <p className="text-slate-500 text-sm mt-3">ログイン不要で使いはじめられます（Drive保存は任意）</p>
      </div>

      <section className="grid gap-4 sm:grid-cols-2 mb-12">
        {FEATURES.map((f) => (
          <div key={f.title} className="bg-white/80 rounded-2xl p-5 shadow-sm border border-gray-200">
            <div className="text-2xl mb-2" aria-hidden="true">{f.icon}</div>
            <h2 className="font-bold text-slate-800 mb-1 text-base">{f.title}</h2>
            <p className="text-slate-600 text-sm leading-relaxed">{f.desc}</p>
          </div>
        ))}
      </section>

      <footer className="text-center text-slate-500 text-sm border-t border-gray-200 pt-6">
        <p className="mb-2">© 2026 Ensemble PALBA / おまかせ運指くん</p>
        <p className="flex items-center justify-center gap-3">
          <a href="/privacy.html" className="text-slate-500 hover:text-slate-700 underline">プライバシーポリシー</a>
          <span aria-hidden="true">·</span>
          <a href="/terms.html" className="text-slate-500 hover:text-slate-700 underline">利用規約</a>
        </p>
      </footer>
    </div>
  );
};

export default LandingPage;
